import React, { PureComponent } from 'react';
import styled from 'styled-components';


const Label = styled.label`
  font-size: ${(props) => props.typo.fontSize + "px"};
  font-weight: ${(props) => props.typo.fontWeight};
  color: ${(props) => props.color};
  margin-bottom: 27px;
  cursor:pointer;
  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
  font-size: 11px;
    `}
`;
const TextOuter = styled.div`
display: flex;
align-items: center;
justify-content: flex-start;
height: ${(props) => props.height || "auto"};
width: ${(props) => props.width || "auto"};
padding:${(props) => props.padding || "0"};
margin:${(props) => props.margin || "0"};
`
class TextMarginAtom extends PureComponent {

    render() {
        return (
          <TextOuter
            margin={this.props.margin}
            id={this.props.id}
            onClick={this.props.onClick}
          >
            <Label
              typo={this.props.typo}
              color={this.props.color}
              fontSizeM={this.props.fontSizeM}
            >
              {this.props.text}
            </Label>
          </TextOuter>
        );
    }
}


export default TextMarginAtom;